// @flow
import * as React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Time from 'statsradio/domain/time/Time';
import TimeRange from 'common/domain/TimeRange';
import LabeledInput from 'statsradio/components/ui/forms/LabeledInput';
import TimePickerInput from 'statsradio/components/ui/forms/TimePickerInput';
import { Interval } from 'statsradio/domain/reach';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  >:not(:last-child) {
    margin-right: ${props => props.theme.V3.metrics.margin.tiny}px; 
  }
`;

export const START_TIME_PICKER_ID = 'TimeRangePicker_startTime';
export const END_TIME_PICKER_ID = 'TimeRangePicker_endTime';

interface Props {
  timeInterval: Interval;

  onChange: (timeRange: Interval) => void;
  t: any,
}

export function TimeRangePickerInput({ timeInterval, onChange, t }: Props) {
  const step = timeInterval.step;
  const timeRange = new TimeRange(timeInterval.from, timeInterval.to);

  function onTimeRangeChange(newTimeRange: TimeRange) {
    const newTimeInterval = new Interval({ from: newTimeRange.start, to: newTimeRange.end, step });
    onChange(newTimeInterval);
  }

  function onStartChange(start: Time) {
    const newTimeRange = new TimeRange(start.floorMinutes(step).asMoment(), timeRange.end);
    onTimeRangeChange(newTimeRange);
  }

  function onEndChange(end: Time) {
    const newTimeRange = new TimeRange(timeRange.start, end.ceilMinutes(step).asMoment());
    onTimeRangeChange(newTimeRange);
  }

  const start = new Time(timeRange.start);
  const end = new Time(timeRange.end);

  return (
    <Wrapper>
      <LabeledInput label={t('from')} name="timeRange_from">
        <TimePickerInput
          id={START_TIME_PICKER_ID}
          time={start}
          name="timeRange_from"
          onChange={onStartChange}
        />
      </LabeledInput>
      <LabeledInput label={t('to')} name="timeRange_to">
        <TimePickerInput
          id={END_TIME_PICKER_ID}
          time={end}
          name="timeRange_to"
          onChange={onEndChange}
        />
      </LabeledInput>
    </Wrapper>
  );
}

export default translate('metrics')(TimeRangePickerInput);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/parameters/TimeRangePickerInput.js